export type AssetClassDataResponse = {
  assetClassData: {
    [equity: number]: {
      [assetClass: string]: number;
    };
  };
  recommendedAllocation: number;
};

export enum ReallocationChoice {
  LEAVEASIS = "LEAVE_AS_IS",
  REALLOCATE = "REALLOCATE",
}

export const US_STOCK_MARKET = "US Stock Market (LR)";
export const INTL_DEV_EQUITY = "International Developed Equity (MR)";
export const EMER_MARKET_EQUITY = "Emerging Markets Equity (HR)";
export const REAL_ESTATE = "Real Estate (HR)";
export const US_GOVT_BONDS = "US Government Bonds (LR)";
export const US_BONDS = "US Bonds (MR)";
export const INTL_BONDS = "International Bonds (HR)";

export const reallocationAssetMap = {
  95: [
    {
      label: US_STOCK_MARKET,
      value: 54,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 24,
    },
    {
      label: EMER_MARKET_EQUITY,
      value: 12,
    },
    {
      label: REAL_ESTATE,
      value: 5,
    },
    {
      label: US_BONDS,
      value: 4,
    },
    {
      label: INTL_BONDS,
      value: 1,
    },
  ],
  85: [
    {
      label: US_STOCK_MARKET,
      value: 48,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 21,
    },
    {
      label: EMER_MARKET_EQUITY,
      value: 11,
    },
    {
      label: REAL_ESTATE,
      value: 5,
    },
    {
      label: US_BONDS,
      value: 11,
    },
    {
      label: INTL_BONDS,
      value: 4,
    },
  ],
  75: [
    {
      label: US_STOCK_MARKET,
      value: 42,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 19,
    },
    {
      label: EMER_MARKET_EQUITY,
      value: 9,
    },
    {
      label: REAL_ESTATE,
      value: 5,
    },
    {
      label: US_BONDS,
      value: 19,
    },
    {
      label: INTL_BONDS,
      value: 6,
    },
  ],
  65: [
    {
      label: US_STOCK_MARKET,
      value: 36,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 16,
    },
    {
      label: EMER_MARKET_EQUITY,
      value: 8,
    },
    {
      label: REAL_ESTATE,
      value: 5,
    },
    {
      label: US_BONDS,
      value: 26,
    },
    {
      label: INTL_BONDS,
      value: 9,
    },
  ],
  55: [
    {
      label: US_STOCK_MARKET,
      value: 30,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 13,
    },
    {
      label: EMER_MARKET_EQUITY,
      value: 7,
    },
    {
      label: REAL_ESTATE,
      value: 5,
    },
    {
      label: US_GOVT_BONDS,
      value: 7,
    },
    {
      label: US_BONDS,
      value: 26,
    },
    {
      label: INTL_BONDS,
      value: 12,
    },
  ],
  45: [
    {
      label: US_STOCK_MARKET,
      value: 24,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 11,
    },
    {
      label: EMER_MARKET_EQUITY,
      value: 5,
    },
    {
      label: REAL_ESTATE,
      value: 5,
    },
    {
      label: US_GOVT_BONDS,
      value: 8,
    },
    {
      label: US_BONDS,
      value: 33,
    },
    {
      label: INTL_BONDS,
      value: 14,
    },
  ],
  35: [
    {
      label: US_STOCK_MARKET,
      value: 21,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 9,
    },
    {
      label: REAL_ESTATE,
      value: 5,
    },
    {
      label: US_GOVT_BONDS,
      value: 9,
    },
    {
      label: US_BONDS,
      value: 40,
    },
    {
      label: INTL_BONDS,
      value: 16,
    },
  ],
  25: [
    {
      label: US_STOCK_MARKET,
      value: 18,
    },
    {
      label: INTL_DEV_EQUITY,
      value: 7,
    },

    {
      label: US_GOVT_BONDS,
      value: 10,
    },
    {
      label: US_BONDS,
      value: 47,
    },
    {
      label: INTL_BONDS,
      value: 18,
    },
  ],
};

export const UNKNOWN = "UNKNOWN";

export enum FinancialEducation {
  NOVICE = "NOVICE",
  MODERATE = "MODERATE",
  EXPERT = "EXPERT",
}

export enum VolatilityTolerance {
  LOW = "LOW",
  MEDIUM = "MEDIUM",
  HIGH = "HIGH",
}

export enum FinancialGoal {
  PRESERVATION = "PRESERVATION",
  BALANCED = "BALANCED",
  GROWTH = "GROWTH",
}

export enum InvestmentPreference {
  RISK_AVERSE = "RISK_AVERSE",
  MODERATE_RISK = "MODERATE_RISK",
  RISK_TAKER = "RISK_TAKER",
}

export enum InheritanceInvestment {
  IRA = "IRA",
  STOCKS = "STOCKS",
  SAVINGS = "SAVINGS",
}

export const targetReturnMap = {
  0: "1% - 3%",
  1: "4% - 5%",
  2: "6% - 7%",
  3: "8% - 9%",
  4: "10% or more",
};

export const targetReturnClassMap = {
  0: [
    {
      assetClass: "Money Market",
      expectedReturn: 2.35,
    },
    {
      assetClass: "Cash Account",
      expectedReturn: 2.35,
    },
  ],
  1: [
    {
      assetClass: "US Government Bonds",
      expectedReturn: 5.59,
    },
    {
      assetClass: "US Corporate Bonds",
      expectedReturn: 5.44,
    },
    {
      assetClass: "International Bonds",
      expectedReturn: 5.78,
    },
    {
      assetClass: "US Bonds",
      expectedReturn: 5.26,
    },
  ],
  2: [
    {
      assetClass: "US Large Cap Equity",
      expectedReturn: 9.95,
    },
    {
      assetClass: "International Developed Equity",
      expectedReturn: 5.28,
    },
    {
      assetClass: "US Stock Market",
      expectedReturn: 10.02,
    },
  ],
  3: [
    {
      assetClass: "US Mid Cap Equity",
      expectedReturn: 11.8,
    },
    {
      assetClass: "US Small Cap Equity",
      expectedReturn: 10.5,
    },
  ],
  4: [
    {
      assetClass: "Emerging Markets Equity",
      expectedReturn: 6.66,
    },
    {
      assetClass: "Real Estate",
      expectedReturn: 10.4,
    },
  ],
};

export type ReallocationSurveyData = {
  ages?: {
    current?: number;
    retirement?: number;
  };
  financialEducation?: FinancialEducation;
  volatilityTolerance?: VolatilityTolerance;
  financialGoal?: FinancialGoal;
  investmentPreference?: InvestmentPreference;
  inheritanceInvestment?: InheritanceInvestment;
  targetReturn?: typeof targetReturnMap[keyof typeof targetReturnMap];
  selfClaimedRiskTolerance?: number;
};

export enum AssetAllocationClass {
  NINETYFIVE = "95-5",
  EIGHTYFIVE = "85-15",
  SEVENTYFIVE = "75-25",
  SIXTYFIVE = "65-35",
  FIFTYFIVE = "55-45",
  FORTYFIVE = "45-55",
  THIRTYFIVE = "35-65",
  TWENTYFIVE = "25-75",
}

export const transformAssetClass = (equity: number): AssetAllocationClass => {
  switch (equity) {
    case 95:
      return AssetAllocationClass.NINETYFIVE;
    case 85:
      return AssetAllocationClass.EIGHTYFIVE;
    case 75:
      return AssetAllocationClass.SEVENTYFIVE;
    case 65:
      return AssetAllocationClass.SIXTYFIVE;
    case 55:
      return AssetAllocationClass.FIFTYFIVE;
    case 45:
      return AssetAllocationClass.FORTYFIVE;
    case 35:
      return AssetAllocationClass.THIRTYFIVE;
    case 25:
      return AssetAllocationClass.TWENTYFIVE;
    default:
      return AssetAllocationClass.EIGHTYFIVE;
  }
};

export type ReallocationData = {
  reallocationChoice?: ReallocationChoice | typeof UNKNOWN;
  reallocationSurvey?: ReallocationSurveyData;
  reallocationRecommendations?: AssetAllocationClass | typeof UNKNOWN;
  reallocationSelection?: AssetAllocationClass | typeof UNKNOWN;
};
